import styles from "./GetInTouchSection.module.scss";
import {useTranslation} from "react-i18next";
import useAppSelector from "../../../hooks/useAppSelector";
import markSvg from "../../../assets/images/get-in-touch/mark.svg";
import phoneSvg from "../../../assets/images/get-in-touch/phone.svg";
import facebookSvg from "../../../assets/images/get-in-touch/facebook.svg";
import instagramSvg from "../../../assets/images/get-in-touch/instagram.svg";
import mailSvg from "../../../assets/images/get-in-touch/mail.svg";
import CustomButton from "../../../components/UI/CustomButton/CustomButton";
import {useNavigate} from "react-router-dom";
import {useEffect, useState} from "react";
import {IGymDetails} from "../../../models/GymSettings";
import {GymSettingsService} from "../../../services/gymSettings.service";

const GetInTouchSection = () => {

    const {t} = useTranslation();
    const {content} = useAppSelector(state => state.siteContentSlice);

    const [gymDetails, setGymDetails] = useState<IGymDetails | null>(null);

    const navigate = useNavigate();

    useEffect(() => {
        getGymDetails()
    }, []);

    const getGymDetails = async () => {
        try {
            const response = await GymSettingsService.getGymLocation();
            setGymDetails(response.data.data)
        } catch (e) {}
    }

    return (
        <section className={styles.section}>
            <div className={styles.content}>
                <div className={"container"}>
                    <div className={styles.wrapper}>
                        <h3 className={styles.title}>{t("GetInTouch")}</h3>
                        <div className={styles.infoItem}>
                            <img src={phoneSvg} alt={'phone number'}/>
                            <a target={"_blank"}
                               href={`tel:${content.getItTouchPhoneNumber}`}>{content.getItTouchPhoneNumber}</a>
                        </div>
                        {
                            gymDetails && (
                                <div className={styles.infoItem}>
                                    <img src={markSvg} alt={'mark'}/>
                                    <a>{gymDetails.streetNumber} {gymDetails.street} {gymDetails.city}, {gymDetails.country} {gymDetails.postcode}</a>
                                </div>
                            )
                        }
                        <div className={styles.socials}>
                            <a target={"_blank"} href={content.getItTouchFacebookLink}>
                                <img src={facebookSvg} alt={'facebook'}/>
                            </a>
                            <a target={"_blank"} href={content.getItTouchInstagramLink}>
                                <img src={instagramSvg} alt={'instagram'}/>
                            </a>
                            <a target={"_blank"} href={`mailto:${content.getItTouchGmailLink}`}>
                                <img src={mailSvg} alt={'gmail'}/>
                            </a>
                        </div>
                        <div className={styles.btnWrapper}>
                            <CustomButton
                                text={t("ContactUs")}
                                type={"button"}
                                typeStyle={"fill"}
                                borderRadius={false}
                                functionOnClick={() => navigate("/contact-us")}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default GetInTouchSection;